import React from 'react';
import { XCircle } from 'lucide-react';
import { symptoms } from '../data/kit';
export function Problem() {
  return <section className="bg-cream-100 py-8 md:py-16 px-4" data-id="element-196" data-mp="2pefolmwyeac9">
      <div className="max-w-3xl mx-auto" data-id="element-197" data-mp="2bfpri7a4wanw">
        <h2 className="font-serif text-[24px] md:text-[40px] font-bold text-center text-wine leading-[1.12] tracking-tight" data-id="element-198" data-mp="2bexx2zs9wiz7">
          TENÉS INFORMACIÓN.{' '}
          <span className="block text-rose-600 mt-1" data-id="element-199" data-mp="21q6bd9dt2uwq">
            LO QUE FALTA ES SABER CÓMO ORDENARLA.
          </span>
        </h2>

        <div className="mt-4 md:mt-7 text-center max-w-xl mx-auto space-y-2.5 md:space-y-3" data-id="element-200" data-mp="26ho97okj8fdh">
          <p className="text-[15px] md:text-lg text-ink-muted leading-snug" data-id="element-201" data-mp="1sq9hmtck75ut">
            Buscás el sueño por un lado. Los sofocos por otro. Después aparecen
            consejos sobre alimentación, ejercicio, estrés o suplementos.
          </p>
          <p className="text-[15px] md:text-lg font-semibold text-ink leading-snug" data-id="element-202" data-mp="1it51ba5ea4lx">
            El problema es que nadie te muestra cómo conectar todo eso con lo
            que vos estás sintiendo.
          </p>
        </div>

        <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3 mt-5 mb-6 md:mt-8 md:mb-10" data-id="element-203" data-mp="ob3y03k8tret">
          {symptoms.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl border border-rose-200 bg-white px-4 py-3 md:px-5 md:py-4" data-id="element-204" data-mp="129bvqdp3swr1">
              <XCircle className="w-5 h-5 md:w-6 md:h-6 text-rose-500 shrink-0" data-id="element-205" data-mp="9l691lehoxok" />
              <span className="text-ink text-[15px] md:text-base font-medium leading-snug" data-id="element-206" data-mp="5kmbigq07s1w">
                {item}
              </span>
            </li>)}
        </ul>

        <div className="text-center max-w-xl mx-auto" data-id="element-207" data-mp="jdlrejtp7o9z">
          <p className="font-serif text-[20px] md:text-[28px] font-bold text-wine leading-tight tracking-tight" data-id="element-208" data-mp="ek92e8l3xfgp">
            Por eso el Kit no empieza diciéndote qué hacer.
          </p>
          <p className="text-[15px] md:text-lg font-bold text-rose-700 mt-1.5 leading-snug" data-id="element-209" data-mp="3i0pwu4we5nw8">
            Primero te ayuda a entender, identificar y priorizar.
          </p>
        </div>
      </div>
    </section>;
}